import { useQuery, useQueryClient } from '@tanstack/react-query';
import {
    requestCallSummary,
    requestCallTranscript,
    requestChatReply,
    requestRegenerateCallSummary,
    requestRegenerateCallTranscript,
} from '../ai/ai';
import { AiPromptStreamRequest, CallSummaryResponse, ChatReplyResponse } from '../ai/types/Ai';

export const useAiChatReply = (props: AiPromptStreamRequest) => {
    return useQuery<ChatReplyResponse>({
        queryKey: ['aiPromptStream', props],
        queryFn: async ({ signal }) => {
            return (await requestChatReply(props, signal)).data;
        },
        retry: 0,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        enabled: false, //only fetch on demand (when user clicks on the button)
    });
};

export const useAiCallTranscript = (props: AiPromptStreamRequest) => {
    return useQuery<string>({
        queryKey: ['aiPromptTranscript', props],
        queryFn: async ({ signal }) => {
            return (await requestCallTranscript(props, signal)).data;
        },
        enabled: !!props,
    });
};

export const useAiRegenerateCallTranscript = (props: AiPromptStreamRequest) => {
    const queryClient = useQueryClient();
    return useQuery<string>({
        queryKey: ['aiPromptRegenerateTranscript', props],
        queryFn: async ({ signal }) => {
            const data = (await requestRegenerateCallTranscript(props, signal)).data;
            queryClient.setQueryData(['aiPromptTranscript'], data);
            return data;
        },
        retry: 0,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        enabled: false, //only fetch on demand (when user clicks on the button)
    });
};

export const useAiCallSummary = (props: AiPromptStreamRequest) => {
    return useQuery<CallSummaryResponse>({
        queryKey: ['aiCallSummary', props],
        queryFn: async ({ signal }) => {
            return (await requestCallSummary(props, signal)).data;
        },
        enabled: !!props,
    });
};

export const useAiRegenerateCallSummary = (props: AiPromptStreamRequest) => {
    const queryClient = useQueryClient();
    return useQuery<CallSummaryResponse>({
        queryKey: ['aiRegenerateCallSummary', props],
        queryFn: async ({ signal }) => {
            const data = (await requestRegenerateCallSummary(props, signal)).data;
            queryClient.setQueriesData({ queryKey: ['aiCallSummary'] }, data);
            return data;
        },
        enabled: false, //only fetch on demand (when user clicks on the button)
        refetchOnWindowFocus: false,
        retry: 0,
        staleTime: Infinity,
    });
};
